import type { DetectedPlugin } from '../types';
import vst2IdsData from '../data/vst2Ids.json';

const vst2Ids = vst2IdsData as Record<
  string,
  { name: string; vendor?: string }
>;

/**
 * Scan raw bytes for printable 4-byte sequences matching known VST2 plugin IDs.
 * Uses a sliding 4-byte window over the entire file.
 */
export function scanVst2Ids(bytes: Uint8Array): DetectedPlugin[] {
  const found: DetectedPlugin[] = [];
  const seen = new Set<string>();

  for (let i = 0; i <= bytes.length - 4; i++) {
    const b0 = bytes[i];
    const b1 = bytes[i + 1];
    const b2 = bytes[i + 2];
    const b3 = bytes[i + 3];

    // All four bytes must be printable ASCII
    if (
      b0 >= 32 &&
      b0 <= 126 &&
      b1 >= 32 &&
      b1 <= 126 &&
      b2 >= 32 &&
      b2 <= 126 &&
      b3 >= 32 &&
      b3 <= 126
    ) {
      const key =
        String.fromCharCode(b0) +
        String.fromCharCode(b1) +
        String.fromCharCode(b2) +
        String.fromCharCode(b3);

      if (!seen.has(key) && key in vst2Ids) {
        seen.add(key);
        const entry = vst2Ids[key];
        found.push({
          name: entry.name,
          vendor: entry.vendor,
          pluginType: 'VST2',
          vst2Id: key,
          confidence: 0.75,
          detectionMethod: 'vst2id',
        });
      }
    }
  }

  return found;
}
